// // image for the current page
// import Restaurant from "../../../asset/solution/restaurants.png";
// import Hotel from "../../../asset/solution/hotel.png";
// import Business from "../../../asset/solution/BusinessConsultants.png";
// import Nonprofits from "../../../asset/solution/Nonprofits.png";

// //vector
// import PDF from "../../../asset/solution/vector/pdf.png";
// import AppStore from "../../../asset/solution/vector/appStore.png";
// import vCard from "../../../asset/solution/vector/vCard.png";
// import Instagram from "../../../asset/solution/vector/Instagram.png";
// import Twitter from "../../../asset/solution/vector/Twitter.png";
// import Spotify from "../../../asset/solution/vector/Spotify.png";

// //active member image
// import Contnet from "../../../asset/solution/content.png";
// import Collaborations from "../../../asset/solution/collaborations.png";
// import Files from "../../../asset/solution/files.png";
// import Styles from "../../../asset/solution/styles.png";
// import Support from "../../../asset/solution/support.png";
// import Organized from "../../../asset/solution/organized.png";

export const qrCodeUses = [
    {
        id: 1,
        title: "Add your QR code details",
        heading:
            "Add your QR code details, select a shape, and apply your brand colours.",
      
    },
    {
        id: 2,
        title: "Add a logo",
        heading:"Upload a small square icon as your logo to be added to the centre of your QR code. Learn more about adding symbols to  <a href='/qr-code-free-with-logo' class='useAnchorLink'>free qr code generator with logo</a>.",
    },
    {
        id: 3,
        title: "Sign up to track & edit your code",
        heading:
            "You can now <a href='/' class='useAnchorLink'> download and utilise the QR code</a> that has been generated for you. Currently, in order to change the scan destination of your QR code in the future, you must register.",
      
    },
   
];

